export default ".BlockSocial-Item {\n  text-align: center;\n}\n.BlockSocial-Item img {\n  margin: 0 auto;\n}\n";